export type ExampleInspection = {
  id: string;
  taskId: string;
  description: string;
  inspectionDate: string;
  typeName: string;
  siteName: string;
  turbineName: string;
  assetType: string;
  asset: string;
  vendor: string;
};
export const EXAMPLE_INSPECTIONS: ExampleInspection[] = [
  {
    id: 'Turbine 1 Inspection',
    taskId: 'eada7e20-eff0-11f0-916d-325096b39f47',
    description: 'Manual Drone Inspection of Turbine 1',
    inspectionDate: '12/18/25',
    typeName: 'Manual Drone',
    siteName: 'Site 1',
    turbineName: 'Turbine 1',
    assetType: 'Nacelle',
    asset: '12345',
    vendor: 'Third Party',
  },
  {
    id: 'Turbine 2 Inspection',
    taskId: '',
    description: 'Automated Drone Inspection',
    inspectionDate: '1/19/2026',
    typeName: 'Autonomous Drone',
    siteName: 'Site 1',
    turbineName: 'Turbine 2',
    assetType: '',
    asset: '',
    vendor: '',
  },
  {
    id: 'Turbine 2 Inspection',
    taskId: '',
    description: 'Internal Crawler Inspection of Turbine 2',
    inspectionDate: '2026-10-22',
    typeName: 'Blade Internal',
    siteName: 'Site 1',
    turbineName: 'Turbine 2',
    assetType: '',
    asset: '',
    vendor: 'Third Party',
  },
];

export type ExampleImageDetails = {
  id: string;
  taskId: string;
  path: string;
  imageUrl: string;
  blade: string;
  bladeChamber: string;
  bladeSide: string;
  radialDistance: number | '';
  height: number | '';
  direction: string;
};
export const EXAMPLE_IMAGE_DETAILS: ExampleImageDetails[] = [
  {
    id: 'Turbine 1 Inspection',
    taskId: 'eada7e20-eff0-11f0-916d-325096b39f47',
    path: 'path/to/image2.jpg',
    imageUrl: 'https://example.com/image2',
    blade: 'A',
    bladeChamber: 'between_web_2',
    bladeSide: 'suction_side',
    radialDistance: 10.2,
    height: '',
    direction: '',
  },
  {
    id: 'Turbine 1 Inspection',
    taskId: '',
    path: 'path/to/image3.jpg',
    imageUrl: '',
    blade: 'B',
    bladeChamber: 'between_web_1',
    bladeSide: 'leading_edge',
    radialDistance: 22.2,
    height: '',
    direction: '',
  },
  {
    id: 'Turbine 2 Inspection',
    taskId: '',
    path: 'path/to/image4.jpg',
    imageUrl: '',
    blade: 'A',
    bladeChamber: 'leading_edge',
    bladeSide: 'pressure_side',
    radialDistance: 33.3,
    height: '',
    direction: '',
  },
  {
    id: 'Turbine 2 Inspection',
    taskId: '',
    path: 'path/to/image5.jpg',
    imageUrl: '',
    blade: 'A',
    bladeChamber: 'root',
    bladeSide: 'pressure_side',
    radialDistance: 33.3,
    height: '',
    direction: '',
  },
];
